// extracted by mini-css-extract-plugin
export default {"tag":"CustomTag_tag__X6-gr","tag_red":"CustomTag_tag_red__Tcwxx","tag_green":"CustomTag_tag_green__hCFZ7","tag_blue":"CustomTag_tag_blue__s0zGL"};